import React, { useState } from 'react';

export default function Welcome({ onCreateList }) {
  const [listName, setListName] = useState('');
  const [isCreating, setIsCreating] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!listName.trim()) return;

    setIsCreating(true);
    try {
      await onCreateList(listName.trim());
      setListName('');
    } catch (error) {
      console.error('Error creating list:', error);
      alert('Failed to create list. Please try again.');
    } finally {
      setIsCreating(false);
    }
  };

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <div className="welcome-header">
          <h1 className="welcome-title">Welcome to Windmill</h1>
          <p className="welcome-subtitle">
            Get started by creating your first list. Organize your tasks and stay focused on what matters most.
          </p>
        </div>

        <div className="welcome-form-card">
          <form onSubmit={handleSubmit} className="welcome-form">
            <label htmlFor="first-list-name" className="welcome-form-label">
              Name your first list
            </label>
            <input
              id="first-list-name"
              type="text"
              value={listName}
              onChange={(e) => setListName(e.target.value)}
              placeholder="e.g., Work, Personal, Shopping"
              className="input-custom welcome-input"
              disabled={isCreating}
              autoFocus
              aria-label="First list name"
            />
            <button
              type="submit"
              disabled={isCreating || !listName.trim()}
              className="btn-custom btn-primary-custom welcome-button"
            >
              {isCreating ? 'Creating...' : 'Create List'}
            </button>
          </form>
        </div>

        <div className="welcome-features">
          <h2 className="welcome-features-title">Key Features</h2>
          <div className="welcome-features-grid">
            <div className="welcome-feature">
              <h3 className="welcome-feature-title">Organize Tasks</h3>
              <p className="welcome-feature-text">Group related tasks together in customizable lists</p>
            </div>
            <div className="welcome-feature">
              <h3 className="welcome-feature-title">Prioritize Work</h3>
              <p className="welcome-feature-text">Promote important tasks to your "To Do Today" list</p>
            </div>
            <div className="welcome-feature">
              <h3 className="welcome-feature-title">Daily Habits</h3>
              <p className="welcome-feature-text">Track recurring tasks with visual completion history</p>
            </div>
            <div className="welcome-feature">
              <h3 className="welcome-feature-title">Location-Based Tasks</h3>
              <p className="welcome-feature-text">Automatically surface tasks when you arrive at specific locations</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

